import { OpportunitiesListHeader } from "./components/OpportunitiesListHeader";

export default OpportunitiesListHeader;